import React from 'react';

import CDNImage from './cdn-image';

import '../../styles/common/thumbnail-image.scss';

const ThumbnailImage = (props) => (
  <div className="thumbnail-image-wrapper">
    <div className="thumbnail-image-contents">
      <CDNImage imagePath={props.imagePath} alt={props.alt} width={props.width} />
    </div>
  </div>
);

export default ThumbnailImage;